import { css } from '@emotion/react';
import styled from '@emotion/styled';
import tailwindConfig from '../../../tailwind.config';
import tw from 'twin.macro';

// When using :after with Tailwind I encounter weird errors; missing tw prefix of content, therefore plain CSS is being used
export const Spinner = styled.section`
  ${tw`flex justify-center`}
  ${css`
    &:after {
      content: '';
      width: 50px;
      height: 50px;
      border: 10px solid ${tailwindConfig.theme.colors.neutrals.n3};
      border-top-color: ${tailwindConfig.theme.colors.primary.p2};
      border-radius: 50%;
      animation: loading 1s ease infinite;
    }
    @keyframes loading {
      to {
        transform: rotate(1turn);
      }
    }
  `}
`;
